const imageHasAlt = (image) => {
  if (!image) return true;
  if (!image.hasAttribute("alt")) {
    console.error("Image elements require alt text");
    return false;
  }
  return true;
};
export {
  imageHasAlt
};
//# sourceMappingURL=imageHasAlt.js.map
